<template>
    <div class="news-entry">
      <v-row class="ma-0 py-4 py-md-7">
        <v-col class="col-12 pa-0">
          <Banner v-if="latestNews.length > 0" :items="latestNews" @itemClicked="newsItemOnClick"></Banner>
        </v-col>
      </v-row>
      <Card>
        <v-row class="ma-0 py-4 py-md-7">
          <v-col class="col-12 pa-0">
            <List head headTitle1="标题" headTitle2="发布时间" :list="news[skip]" :loading="loading" @clickItem="newsItemOnClick">
            </List>
            <v-pagination
              class="pagination align-self-center align-self-md-end mb-4 mr-5"
              v-if="pagination"
              :value="skip + 1"
              :length="paginationLength"
              :total-visible="7"
              color="primary"
              @input="input"
          ></v-pagination>
          </v-col>
        </v-row>
      </Card>
    </div>

</template>

<script>
import { Card, List } from '@/components/UI'
import Banner from './Banner'
import { News, LatestNews } from '@/mixins/news'
export default {
  name: 'NewsEntry',
  mixins: [News, LatestNews],
  components: {
    Card,
    List,
    Banner
  },
  async mounted () {
    await this.getLatestNews()
    await this.getNews()
  }
}
</script>

<style lang="scss" scoped>
</style>
